<!-- Carousel Reviews -->
<div
  class="relative"
  [class]="backgroundClass"
  [style.backgroundImage]="backgroundImageUrl ? 'url(' + backgroundImageUrl + ')' : null"
  >
  <div class="container mx-auto {{ containerClasses }}">
    @if (title) {
      <div class="wysiwyg carousel-title sm:px-v-spacing max-w-container mx-auto" [innerHTML]="title"></div>
    }
    <div class="swiper mx-auto" #swiperContainer>
      <div class="swiper-wrapper">
        @for (slide of sliderReviews; track slide) {
          <div class="swiper-slide">
            <div class="slide-container">
              <p class="mb-v-spacing text-base md:text-lg font-light">"{{ slide.review }}"</p>
              <p class="mb-v-spacing text-base md:text-md sm:px-24 md:px-0">
                <span class="font-bold">{{ slide.name }}</span
                  >, <span class="font-light">{{ slide.date }}</span>
                </p>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="{{ prevSlide }} swiper-button-prev"></div>
      <div class="{{ nextSlide }} swiper-button-next"></div>
    </div>
  </div>
